// extracted by mini-css-extract-plugin
export var dropZoneViewServiceIcon = "drop-zone-view__service-icon_bUYOjaJysLJWI8hzSmoH";